"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import Link from "next/link"; // Importing Link from Next.js
import Image from "next/image";

export default function HeroMainBanner({
  data,
  bannerMediaData,
  isDesktop,
  isMuted,
  videoRefs,
  isVideo,
  getMediaSource,
}: any) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isVideoReady, setIsVideoReady] = useState(false);

  if (!bannerMediaData) return null;

  const mediaSrc = getMediaSource(bannerMediaData);
  const btnLink = bannerMediaData?.btnLink || null; // Accessing the btnLink from the data

  return (
    <div className={`relative ${isDesktop ? "h-screen" : "h-screen"} w-full`}>
      {isVideo(bannerMediaData) ? (
        // Wrap the video element with a Link to make it clickable
        <Link href={btnLink || "#"} passHref>
          <video
            className={`w-full h-full object-cover transition-opacity duration-700`}
            autoPlay
            loop
            muted={isMuted}
            playsInline
            preload="auto"
            poster="https://cfc-images.sgp1.digitaloceanspaces.com/OexTech/crunchyfashion%40oextech.com/Crunchy%20Fashion/posterimage.png"
            ref={(el) => {
              if (el) {
                el.oncanplaythrough = () => setIsVideoReady(true);
                videoRefs.current[0] = el;
              }
            }}
          >
            <source src={mediaSrc} type="video/mp4" />
            <source src={mediaSrc.replace(".mp4", ".webm")} type="video/webm" />
          </video>
        </Link>
      ) : (
        <Image
          src={mediaSrc}
          alt={bannerMediaData.title || "Hero image"}
          fill
          quality={80}
          sizes="100vw"
          priority
          placeholder="blur"
          blurDataURL="/lowres-placeholder.webp"
          className={`object-cover transition-opacity duration-700 ${
            isImageLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setIsImageLoaded(true)}
        />
      )}

      {/* <div className="absolute inset-0 flex items-center justify-center">
        <div className="container relative mx-auto px-6 mt-14 text-center">
          {data?.title && (
            <div className="mb-10">
              <motion.h1
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, ease: [0.215, 0.61, 0.355, 1] }}
                className="text-5xl md:text-6xl lg:text-7xl xl:text-7xl font-light   tracking-tighter mb-8 text-white"
              >
                {data.title
                  .split(",")
                  .map((part: string, index: number, array: string[]) => (
                    <motion.span
                      key={index}
                      className="block overflow-hidden"
                      initial={{ y: "100%" }}
                      animate={{ y: 0 }}
                      transition={{
                        duration: 1,
                        delay: index * 0.1,
                        ease: [0.215, 0.61, 0.355, 1],
                      }}
                    >
                      <span
                        className={`block pb-2 ${
                          index === 0 ? "font-normal  " : ""
                        } ${
                          index === array.length - 1
                            ? "italic font-light"
                            : "font-light"
                        } ${index % 2 === 0 ? "text-white" : "text-gray-100"}`}
                      >
                        {part.trim()}
                        {index < array.length - 1 && (
                          <span className="inline-block mx-2 w-2 h-2 bg-white rounded-full align-middle opacity-50  "></span>
                        )}
                      </span>
                    </motion.span>
                  ))}
              </motion.h1>
            </div>
          )}

          {data?.subtitle && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="text-xl md:text-2xl font-light max-w-2xl mx-auto mb-12 text-white/80 tracking-wider uppercase"
            >
              {data.subtitle}
            </motion.p>
          )}

          {data?.btnLink && data?.btnText && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="mt-12 md:mt-16"
            >
              <Link href={data.btnLink} passHref>
                <button className="group relative px-16 py-5 bg-transparent text-white rounded-sm font-medium transition-all duration-700 text-lg overflow-hidden border border-white/40 hover:border-white/80">
                  <span className="relative z-10 tracking-widest uppercase text-sm font-light flex items-center justify-center">
                    {data.btnText}
                    <svg
                      className="w-4 h-4 ml-4 transition-all duration-500 group-hover:translate-x-1 group-hover:scale-110"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </span>
                  <motion.span
                    className="absolute inset-0 border border-white/30"
                    animate={{
                      boxShadow: [
                        "0 0 0px rgba(255,255,255,0.3)",
                        "0 0 10px rgba(255,255,255,0.5)",
                        "0 0 0px rgba(255,255,255,0.3)",
                      ],
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      repeatDelay: 2,
                    }}
                  />
                </button>
              </Link>
            </motion.div>
          )}
        </div>
      </div> */}
    </div>
  );
}

// "use client";
// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import Link from "next/link";
// import Image from "next/image";

// export default function HeroMainBanner({
//   data,
//   bannerMediaData,
//   isDesktop,
//   isMuted,
//   videoRefs,
//   isVideo,
//   getMediaSource,
// }: any) {
//   const [isImageLoaded, setIsImageLoaded] = useState(false);
//   const [isVideoReady, setIsVideoReady] = useState(false);

//   if (!bannerMediaData) return null;

//   const mediaSrc = getMediaSource(bannerMediaData);

//   return (
//     <div className={`relative ${isDesktop ? "h-screen" : "h-screen"} w-full`}>
//       {isVideo(bannerMediaData) ? (
//         <video
//           className={`w-full h-full object-cover transition-opacity duration-700 `}
//           autoPlay
//           loop
//           muted={isMuted}
//           playsInline
//           preload="auto"
//           poster="https://cfc-images.sgp1.digitaloceanspaces.com/OexTech/crunchyfashion%40oextech.com/Crunchy%20Fashion/posterimage.png"
//           ref={(el) => {
//             if (el) {
//               el.oncanplaythrough = () => setIsVideoReady(true);
//               videoRefs.current[0] = el;
//             }
//           }}
//         >
//           <source src={mediaSrc} type="video/mp4" />
//           <source src={mediaSrc.replace(".mp4", ".webm")} type="video/webm" />
//         </video>
//       ) : (
//         <Image
//           src={mediaSrc}
//           alt={bannerMediaData.title || "Hero image"}
//           fill
//           quality={80}
//           sizes="100vw"
//           priority
//           placeholder="blur"
//           blurDataURL="/lowres-placeholder.webp"
//           className={`object-cover transition-opacity duration-700 ${
//             isImageLoaded ? "opacity-100" : "opacity-0"
//           }`}
//           onLoad={() => setIsImageLoaded(true)}
//         />
//       )}

//       <div className="absolute inset-0 flex items-center justify-center">
//         <div className="container relative mx-auto px-6 mt-14 text-center">
//           {data?.title && (
//             <div className="mb-10">
//               <motion.h1
//                 initial={{ opacity: 0, y: 40 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 1.2, ease: [0.215, 0.61, 0.355, 1] }}
//                 className="text-5xl md:text-6xl lg:text-7xl xl:text-7xl font-light   tracking-tighter mb-8 text-white"
//               >
//                 {data.title
//                   .split(",")
//                   .map((part: string, index: number, array: string[]) => (
//                     <motion.span
//                       key={index}
//                       className="block overflow-hidden"
//                       initial={{ y: "100%" }}
//                       animate={{ y: 0 }}
//                       transition={{
//                         duration: 1,
//                         delay: index * 0.1,
//                         ease: [0.215, 0.61, 0.355, 1],
//                       }}
//                     >
//                       <span
//                         className={`block pb-2 ${
//                           index === 0 ? "font-normal  " : ""
//                         } ${
//                           index === array.length - 1
//                             ? "italic font-light"
//                             : "font-light"
//                         } ${index % 2 === 0 ? "text-white" : "text-gray-100"}`}
//                       >
//                         {part.trim()}
//                         {index < array.length - 1 && (
//                           <span className="inline-block mx-2 w-2 h-2 bg-white rounded-full align-middle opacity-50  "></span>
//                         )}
//                       </span>
//                     </motion.span>
//                   ))}
//               </motion.h1>
//             </div>
//           )}

//           {data?.subtitle && (
//             <motion.p
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 1, delay: 0.6 }}
//               className="text-xl md:text-2xl font-light max-w-2xl mx-auto mb-12 text-white/80 tracking-wider uppercase"
//             >
//               {data.subtitle}
//             </motion.p>
//           )}

//           {data?.btnLink && data?.btnText && (
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8, delay: 0.8 }}
//               className="mt-12 md:mt-16"
//             >
//               <Link href={data.btnLink} passHref>
//                 <button className="group relative px-16 py-5 bg-transparent text-white rounded-sm font-medium transition-all duration-700 text-lg overflow-hidden border border-white/40 hover:border-white/80">
//                   <span className="relative z-10 tracking-widest uppercase text-sm font-light flex items-center justify-center">
//                     {data.btnText}
//                     <svg
//                       className="w-4 h-4 ml-4 transition-all duration-500 group-hover:translate-x-1 group-hover:scale-110"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="1.5"
//                         d="M14 5l7 7m0 0l-7 7m7-7H3"
//                       />
//                     </svg>
//                   </span>
//                   <motion.span
//                     className="absolute inset-0 border border-white/30"
//                     animate={{
//                       boxShadow: [
//                         "0 0 0px rgba(255,255,255,0.3)",
//                         "0 0 10px rgba(255,255,255,0.5)",
//                         "0 0 0px rgba(255,255,255,0.3)",
//                       ],
//                     }}
//                     transition={{
//                       duration: 3,
//                       repeat: Infinity,
//                       repeatDelay: 2,
//                     }}
//                   />
//                 </button>
//               </Link>
//             </motion.div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
